<div class="rule-header">
  <div class="d-flex flex-row flex-wrap mb-2 column-gap-3">
    <h2 data-test-id="rule-info-title">{{ scanIssues[$scanIssues.title] }}</h2>
    @if (
      scanIssues[$scanIssues.toolName] === AccessibilityAuditToolNames.access_engine &&
      scanIssues[$scanIssues.hasAutomatedRemediation]
    ) {
      <ds-chip
        data-test-id="art-chip"
        [text]="'automated_remediation_available_label' | translate"
        [colorVariant]="DsChipColorVariant.LightBlue"
      ></ds-chip>
    }
  </div>
  <div class="d-flex flex-column flex-md-row">
    <div class="me-0 mb-2 me-md-4 mb-md-0 me-xl-5">
      <div class="label">{{ 'label_tool' | translate }}</div>
      <div data-test-id="rule-info-tool-name">
        {{ 'scan_results_tool_option_' + scanIssues[$scanIssues.toolName] | translate }}
      </div>
    </div>
    <div class="me-0 mb-2 me-md-4 mb-md-0 me-xl-5">
      <div class="label">{{ 'label_severity' | translate }}</div>
      <div class="" data-test-id="rule-info-severity">
        @if (customSeverity$ | async; as customSeverity) {
          <table-cell-custom-severity
            [config]="{
              severity: this.scanIssues[$scanIssues.severity],
              customSeverity: customSeverity,
            }"
          ></table-cell-custom-severity>
        } @else {
          <table-cell-severity
            [config]="{
              severity: this.scanIssues[$scanIssues.severity],
            }"
          ></table-cell-severity>
        }
      </div>
    </div>
    <div class="me-0 mb-2 me-md-4 mb-md-0 me-xl-5">
      <div class="label">
        {{ 'audit_rule_property_success_criteria_criteria_and_standard' | translate }}
      </div>
      <div class="">
        <ul class="list-unstyled mb-0">
          @for (sc of successCriteria; track $index) {
            <li data-test-id="rule-info-success-criteria">
              @if (sc) {
                <ng-template #scText>
                  {{ sc.num }} {{ sc.handle }} &ndash;
                  {{ sc.standard }}
                  {{ sc.versions }}
                  {{ sc.level }}
                </ng-template>
                @if (sc.url) {
                  <a [href]="sc.url" class="d-block" target="_blank">
                    <ng-container [ngTemplateOutlet]="scText" />
                  </a>
                } @else {
                  <span class="d-block">
                    <ng-container [ngTemplateOutlet]="scText" />
                  </span>
                }
              }
            </li>
          }
        </ul>
      </div>
    </div>
    <div>
      <div class="label">{{ 'audit_rule_property_ruleId' | translate }}</div>
      <div class="" data-test-id="rule-info-rule-id">
        {{ scanIssues[$scanIssues.ruleId] }}
      </div>
    </div>
  </div>
</div>
